import React from 'react';
import Skeleton from './Skeleton';

/**
 * CarePackagesSkeleton
 * Shimmer placeholder for the domiciliary Care Packages board:
 *   - header (back + title + search + toggles + actions)
 *   - tools row + week day pills
 *   - a few zone / client cards
 */

const S = Skeleton;

const CarePackagesSkeleton = () => (
  <div className="space-y-4">
    {/* Header */}
    <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-3">
      <div className="flex items-center gap-3">
        <S className="h-9 w-9 rounded-full shrink-0" />
        <div className="space-y-2">
          <S className="h-6 w-44 rounded-lg" />
          <S className="h-3 w-64 rounded-md" />
        </div>
      </div>
      <div className="flex items-center gap-2.5 flex-wrap">
        <S className="h-10 w-[230px] rounded-lg" />
        <S className="h-10 w-28 rounded-lg" />
        <S className="h-10 w-32 rounded-lg" />
        <S className="h-10 w-28 rounded-lg" />
      </div>
    </div>

    {/* Tools row */}
    <div className="flex items-center gap-2.5">
      <S className="h-9 w-40 rounded-lg" />
      <S className="h-9 w-36 rounded-lg" />
    </div>

    {/* Day pills */}
    <div className="flex gap-2">
      {Array.from({ length: 7 }).map((_, i) => <S key={i} className="h-14 flex-1 rounded-xl" />)}
    </div>

    {/* Board */}
    <div className="space-y-3">
      {Array.from({ length: 3 }).map((_, i) => (
        <div key={i} className="rounded-2xl border border-[#E3E9F3] dark:border-gray-800 bg-white dark:bg-[#262b33] p-4 space-y-3">
          <S className="h-4 w-40 rounded-md" />
          {Array.from({ length: 2 }).map((_, j) => (
            <div key={j} className="flex items-center gap-3">
              <S className="h-9 w-9 rounded-full shrink-0" />
              <S className="h-12 flex-1 rounded-lg" />
            </div>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default CarePackagesSkeleton;
